
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/categories/[slug]/locations",
      function () {
        return require("private-next-pages/categories/[slug]/locations.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/categories/[slug]/locations"])
      });
    }
  